/* eslint-disable default-case */
import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { firebase } from 'firebase-config';
import styles from './styles';
import { useSnackbar } from 'notistack';
import { Loader, ActionButtons, Title, ImageBox } from 'components';

const { thumbsContainer, thumb, img, thumbInner, thumbMobile } = styles;

function ImageUploader(props) {
  const { getImageInfo } = props;
  const [file, setFile] = useState([]);
  const [imageData, setImageData] = useState({ image: { width: '', height: '', filename: '' } });
  const [downloadURL, setDownloadUrl] = useState('');
  const [isLoading, setIsloading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  // const [progress, setProgress] = useState(0);
  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    multiple: false,
    onDrop: (acceptedFiles) => {
      setFile(
        acceptedFiles.map((file) => Object.assign(file, {
            preview: URL.createObjectURL(file)
          }))
      );
    }
  });

  const getImageSize = (evt) => setImageData({
      width: evt.target.naturalWidth,
      height: evt.target.naturalHeight,
      filename: file[0].name,
      resized: false
    });
  const showMessage = (variant, message) => {
    enqueueSnackbar(message, { variant });
  };

  const saveFile = (event) => {
    setIsloading(true);
    const metadata = {
      contentType: 'image/png'
    };
    event.preventDefault();
    const ref = firebase.storage().ref('gallery').child(file[0].name);
    const fileUpload = ref.put(new Blob(file), metadata);
    fileUpload.on(
      'state_changed',
      () => {
        // var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        // setProgress(progress)
      },
      (error) => {
        setIsloading(false);
        showMessage('error', error.message);
      },
      () => {
        fileUpload.snapshot.ref.getDownloadURL().then((downloadURL) => {
          getImageInfo({ src: downloadURL, ...imageData });
          setDownloadUrl(downloadURL);
          setIsloading(false);
          showMessage('success', 'File upladed successfully!');
        });
      }
    );
  };

  const preview = file.map((file) => (
    <div style={window.innerWidth <= 768 ? thumb : thumbMobile} key={file.name}>
      <div style={thumbInner}>
        <img onLoad={getImageSize} src={file.preview} style={img} alt="Test" />
      </div>
    </div>
  ));

  const clearImage = () => {
    setFile([]);
    setDownloadUrl('');
  };

  useEffect(
    () => () => {
      file.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [file]
  );
  const noFileSelected = preview && preview.length === 0;
  return (
    <section className="container">
      {isLoading && <Loader isLoading={isLoading} />}
      <div {...getRootProps({ className: 'dropzone' })}>
        <Title title="Adaugă lucrare nouă" />
        <input {...getInputProps()} />
        {noFileSelected && <ImageBox />}
      </div>
      <div style={thumbsContainer}>
        {preview}
        {!noFileSelected && (
          <ActionButtons
            leftText="Curăță"
            leftAction={clearImage}
            rightText={!downloadURL ? 'Încarcă' : 'S-a încărcat'}
            rightAction={saveFile}
            rightDisabled={!!downloadURL.length}
          />
        )}
      </div>
    </section>
  );
}

export default ImageUploader;
